<template>
  <div
    class="flex items-center gap-3 w-full min-w-0"
    :class="collapsed ? 'justify-center' : ''"
    data-testid="sidebar-school-header"
  >
    <div
      class="w-10 h-10 rounded-xl shrink-0 overflow-hidden flex items-center justify-center"
      :class="showLogo ? 'bg-white ring-1 ring-gray-200' : 'bg-primary/10'"
    >
      <img
        v-if="showLogo"
        :src="logo ?? undefined"
        :alt="name ? `${name} logo` : 'School logo'"
        class="w-full h-full object-contain"
        data-testid="sidebar-school-logo"
        @error="logoFailed = true"
      />
      <i v-else class="pi pi-graduation-cap text-primary text-xl" data-testid="sidebar-school-logo-fallback"></i>
    </div>

    <!-- The full name always renders whole — wrap onto as many lines as it
      needs rather than truncating (long tertiary names were unreadable). -->
    <p
      v-if="!collapsed"
      class="flex-1 min-w-0 text-sm font-semibold text-gray-800 leading-snug break-words"
      data-testid="sidebar-school-name"
    >
      {{ name || 'School Portal' }}
    </p>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  name?: string | null
  logo?: string | null
  collapsed?: boolean
}>();

// A stored logo URL can still 404 (deleted upload, dead CDN path) — fall back
// to the icon instead of the browser's broken-image glyph.
const logoFailed = ref(false);
watch(() => props.logo, () => { logoFailed.value = false; });
const showLogo = computed(() => !!props.logo && !logoFailed.value);
</script>
